@if (sanitizedUrl) {
  <!--
  allow autoplay for voting elements in order to play sound without clicking into the elements.
  @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Permissions-Policy#basic_usage
  -->
  <iframe
    allow="autoplay"
    [src]="sanitizedUrl"
    frameborder="0"
    (load)="onIframeLoaded($event.target)"
  ></iframe>
}
